export const FIELD_ID = 'id';
export const FIELD_TYPE = 'type';
export const PROPERTIES = 'properties';
export const FIELD_AREA = 'properties.area';
export const FIELD_CREATED = 'properties.created';
export const FIELD_CREATED_TYPE = 'properties.created_type';
export const FIELD_DISTRICT = 'properties.district';
export const FIELD_NAME = 'properties.name';
export const FIELD_UPDATED = 'properties.updated';
export const DEFAULT_COORDINATES = [30.662925134398773, 49.682169141096566];
